import { apiGet, apiPut } from './client';

export function legacyOfferingToApi(s) {
  return {
    serviceId: Number(s.serviceid || s.serviceId),
    experienceLevel: s.experiencelevel || s.experienceLevel || 'Beginner',
    yearsOfExperience: Number(s.yearofexperience || s.yearsOfExperience || 0),
    hourlyRate: Number(s.hourlyrate || s.hourlyRate || 0),
    currency: s.currency || 'USD',
  };
}

export async function replaceAllServices(offerings) {
  const payload = (offerings || []).map(legacyOfferingToApi);
  return apiPut('/me/services', payload);
}

export async function removeServiceByServiceId(serviceId) {
  const { data: me } = await apiGet('/me');
  const next = (me.services || []).filter(
    (s) => Number(s.serviceId) !== Number(serviceId)
  );
  return apiPut('/me/services', next);
}
